import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { AnnouncementsComponent } from './announcements.component';

@NgModule({
	declarations: [AnnouncementsComponent],
	imports: [CommonModule, SharedModule],
})
export class AnnouncementsModule {}
